const COOKIE_DOMAIN = ".revmatics.ai";
const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

export const setRevmaticsCookie = (name: string, value?: string) => {
  if (!value) return;

  const isSecure = window.location.protocol === "https:";
  const secureFlag = isSecure ? "; Secure" : "";
  const domain = isSecure ? `; domain=${COOKIE_DOMAIN}` : "";
  document.cookie = `${name}=${value}${domain}; path=/; max-age=${MAX_AGE}; SameSite=Lax ${secureFlag}`;
};

export const deleteRevmaticsCookie = (name: string) => {
  const isSecure = window.location.protocol === "https:";
  const secureFlag = isSecure ? "; Secure" : "";

  // 1. delete cookie with domain
  document.cookie = `${name}=; domain=${COOKIE_DOMAIN}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${secureFlag}`;

  // 2. delete cookie without domain (localhost case)
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${secureFlag}`;
};

export const getRevmaticsCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};
